import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface Props {
    hasSkeleton?: boolean | null;
    skeletonType?: 'table' | 'span' | null;
}

export default function Loading({ hasSkeleton= false, skeletonType }: Props){
    return(
        <>
            {
                hasSkeleton && skeletonType === 'table' && 
                <table className='table table-borderless'>
                    <tbody>
                    <tr>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                        <td>
                            <Skeleton/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            }
            {
                hasSkeleton && skeletonType === 'span' &&
                <span>
                    <Skeleton />
                </span>
            }
            {
                !hasSkeleton && <span>Cargando...</span>
            }
        </>
    )
}